import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=6b6d7c07&"
import script from "./Contracts.vue?vue&type=script&lang=js&"
export * from "./Contracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports